import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { smartTagSettingSelector } from "./smartTagSettingSelector";

export const smartTagCustomValueSelector = createDraftSafeSelector(
  [smartTagSettingSelector],
  ({ data }): string => data?.value || "",
);
